import { useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { Confirm } from '../forms/Confirm';
import Textarea from '../forms/Textarea';
import Button from '../ui/Button';
import Modal from '../ui/Modal';

type RejectSaleForm = {
  comment: string;
};

type RejectSaleProps = {
  open: boolean;
  onReject: SubmitHandler<RejectSaleForm>;
  setOpen: (boolean) => void;
};

const RejectSale = ({ open, onReject, setOpen }: RejectSaleProps) => {
  const { register, handleSubmit } = useForm<RejectSaleForm>();
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [block, setBlock] = useState(false);

  const handleOnConfirm = () => {
    setBlock(false);
    setShowConfirmation(false);
    handleSubmit(onReject)();
  };

  const handleOnCancel = () => {
    setBlock(false);
    setShowConfirmation(false);
  };

  return (
    <Modal open={open} setOpen={setOpen} block={block}>
      <Confirm
        title="Are you sure you want to reject the order?"
        open={showConfirmation}
        onConfirm={handleOnConfirm}
        onCancel={handleOnCancel}
        setOpen={(open) => {
          setShowConfirmation(open);
          setBlock(open);
        }}
      />
      <form name="rejectOrderForm" className="flex flex-col">
        <label className="font-bold mb-2">Comment: </label>
        <Textarea
          name="comment"
          register={register}
          options={{ required: true }}
          cols={30}
          rows={5}
          className="mb-2"
        />
      </form>
      <Button
        text="Reject"
        color="red"
        className="w-full"
        onClick={() => {
          setBlock(true);
          setShowConfirmation(true);
        }}
      />
    </Modal>
  );
};

export default RejectSale;
